import React from 'react';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import { OnboardingRoutes } from './OnboardingRoutes';
import { Routes, useLocation } from "react-router-dom";
import { VerifyEmailRoutes } from './VerifyEmailRoutes';
import { StorageItems } from '../../../utils/storageItems';
import { NotAuthenticatedRoutes } from './NotAuthenticatedRoutes';
import { TokenPayload } from "../../../domain/helpers/TokenPayload";

interface RoutePageProps {
  user: TokenPayload | null;
}

export const RoutePage: React.FC<RoutePageProps> = ({ user }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const role =
    user?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  const isAdminRole = role === "Admin";
  const firstTimeLogin = localStorage.getItem(StorageItems.FIRSTTIMELOGIN);

  return <Routes>
    {
      user
        ? <React.Fragment>
          {
            user.emailConfirmed === 'True' && firstTimeLogin === 'true'
              ? OnboardingRoutes()
              : user.emailConfirmed === 'True'
                ? AuthenticatedRoutes({ isAdminRole, pathname })
                : user.emailConfirmed === 'False'
                  ? VerifyEmailRoutes()
                  : null
          }
        </React.Fragment>
        : NotAuthenticatedRoutes()
    }
  </Routes>
};
export default RoutePage;